module.exports = __webpack_public_path__ + "img/productRobot_18.d0f8a430.png";